export default __webpack_public_path__ + "public/static/logo.2563b22f0b33ff9d6687c13ddc610870.svg";